import React from 'react';
import { Message } from 'semantic-ui-react'

const privacyPolicy = () => (
    <div style={{width:'100%'}}>
  <Message> 
     
      <Message.Header>
thundersocialbookmark.com Privacy Policy
       </Message.Header>
       <p> Our social bookmark website recognizes that privacy is extremely important. For example, we do not record users' browsing history, except for the pages you specifically bookmark to our servers, which are located in the United States of America or other countries as well.
Further details of the our privacy policy are outlined below.  </p>

<Message.Header>
Children
</Message.Header>
<p>For children under 13, we offers a limited feature set and website experience. We require consent from a teacher when children under the age of 13 want to register, and offer a limited version of the website that removes certain social features, such as public profile. The only identifiable information we collect from children under 13 is an email address input teachers.Parents can request deletion of student data.Student data are retained only for education purposes.
</p>

<Message.Header>
Information We Collect
</Message.Header>
<p>We collects email address when you register with our service or otherwise voluntarily provide such information. We don't collect other personal information.
Our servers automatically record information when you visit our website or use some of our products, including the URL, IP address, browser type and language, and the date and time of your request. Generally, these information is considered as log information, not personal information .
If you choose to display annotation you made on a webpage automatically, our system extension sends the URL of the page you visit to our servers for the sole purpose of looking up annotations on that page. Such information is not recorded on our servers.
When you bookmark, annotate or forward a page, the URL and the associated annotations you submit will be saved on our servers.
</p>
<p>
The log information is mainly used for usage analysis in Google Analytics, such as how many users access X feature etc.
We may use your bookmarks to provide the services you've requested, including services that display customized content and advertising.
We may also use log information and bookmark information for auditing, research and analysis to operate and improve our technologies and services.
If information is used in any way other than indicated above, it will be in the aggregated form, and with all personal identifications removed.
</p>
<p>
We updated our Privacy Policy to comply with requirements of General Data Protection Regulation (GDPR) which is the European Union data protection law that goes into effect May 25, 2018.
</p>
<Message.Header>
Security
</Message.Header>
<p>
Our member accounts are secured by member-created passwords. We takes precautions to insure that member account information is kept private. We use reasonable measures to protect member information that is stored within our database, and we restrict access to member information to those employees who need access to perform their job functions, such as our customer service personnel and technical staff. Please note that we cannot guarantee the security of member account information. Unauthorized entry or use, hardware or software failure, and other factors may compromise the security of member information at any time.
</p>
<Message.Header>
Changes in Our Privacy Policy
</Message.Header>
<p>
From time to time we may make changes to our privacy policy. If we make changes, we will post them on our site to make users aware of what the changes are so users will always be aware of what information we collect, how we use it, and when we may disclose it. A User is bound by any minor changes to the policy when she or he uses the site after those changes have been posted If, however, we are going to use users' personally identifiable information in a manner materially different from that stated at the time of collection we will notify by posting a notice on our Web site for 30 days.
</p>
Please contact us at heapengineering.com with any questions regarding our privacy policy.
      
      
    
      </Message>
</div>
);
export default privacyPolicy;